module.exports = __webpack_public_path__ + "img/social_economy.e037f7b5.svg";